.b{flex-direction:column;}